import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";
import {CourseComponent} from "../../common/course/course.component";

@Component({
  selector: 'app-kurse',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent,
        CourseComponent
    ],
  templateUrl: './kurse.component.html',
  styleUrl: './kurse.component.scss'
})
export class KurseComponent {

}
